import { Icon } from '@iconify/react'
import { Button, Stack } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import LoadingBtn from '../LoadingBtn'

const SaveCancelButton = ({ isSubmitting, id, page, formik }) => {

    const navigate = useNavigate()
    return (
        <Stack
            spacing={2}
            mt={3}
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
        >
            {isSubmitting ?
                <LoadingBtn />
                :
                <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Icon icon="fa-solid:save" />}
                    disabled={isSubmitting}
                    onClick={() => {
                        if (page == "product") {
                            formik.setFieldTouched("ingredients", true)
                        }
                    }}
                >
                    {id ? "Update" : "Save"}
                </Button>
            }
            <Button
                type="button"
                variant="outlined"
                onClick={() => {
                    if (!isSubmitting)
                        navigate(-1)
                }}
                className='hoverWhite'
                disabled={isSubmitting}
            >
                Cancel
            </Button>
        </Stack>
    )
}

export default SaveCancelButton